import { render } from "./form-land-modal.vue?vue&type=template&id=6bb670ba&scoped=true"
import script from "./form-land-modal.vue?vue&type=script&lang=js"
export * from "./form-land-modal.vue?vue&type=script&lang=js"

import "./form-land-modal.vue?vue&type=style&index=0&id=6bb670ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb670ba"]])

export default __exports__